// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_study_permissions.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.diagnocat.model.StudyPermissions
 */
export const StudyPermissions = proto3.makeMessageType(
  "com.diagnocat.model.StudyPermissions",
  () => [
    { no: 1, name: "CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "CanRequestCBCTGPReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "CanRequestCBCTEndoReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "CanRequestCBCTImplantReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "CanRequestCBCTOrthoSlidesReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "CanRequestCBCTSegmentationReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "CanRequestIOXRayReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "CanRequestPanoReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "CanRequestDentalPhotoReport", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "CanDelete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

